"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDropdownCtx = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var rc_dropdown_1 = tslib_1.__importDefault(require("rc-dropdown"));
var ConfigProvider_1 = require("../ConfigProvider");
var PopupContainerProvider_1 = require("../PopupContainerProvider");
var hooks_1 = require("../utils/hooks");
var autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
// 垂直方向上的默认偏移，单位 px
var defaultOffsetY = 8;
var topOffset = [0, -defaultOffsetY];
var bottomOffset = [0, defaultOffsetY];
var targetOffset = [0, 0];
// 所有支持的 placement 配置
// 在 rc-dropdown 实现的基础上调整了 placement 名 & offset 值，其他保持一致
var placements = {
    topLeft: {
        points: ['bl', 'tl'],
        overflow: autoAdjustOverflow,
        offset: topOffset,
        targetOffset: targetOffset
    },
    top: {
        points: ['bc', 'tc'],
        overflow: autoAdjustOverflow,
        offset: topOffset,
        targetOffset: targetOffset
    },
    topRight: {
        points: ['br', 'tr'],
        overflow: autoAdjustOverflow,
        offset: topOffset,
        targetOffset: targetOffset
    },
    bottomLeft: {
        points: ['tl', 'bl'],
        overflow: autoAdjustOverflow,
        offset: bottomOffset,
        targetOffset: targetOffset
    },
    bottom: {
        points: ['tc', 'bc'],
        overflow: autoAdjustOverflow,
        offset: bottomOffset,
        targetOffset: targetOffset
    },
    bottomRight: {
        points: ['tr', 'br'],
        overflow: autoAdjustOverflow,
        offset: bottomOffset,
        targetOffset: targetOffset
    }
};
var dropdownCtx = react_1.createContext(null);
/** 供 `Dropdown` overlay 内容与 `Dropdown` 进行交互，若当前组件未被 `Dropdown` 包裹，函数返回 `null` */
function useDropdownCtx() {
    return react_1.useContext(dropdownCtx);
}
exports.useDropdownCtx = useDropdownCtx;
exports.default = react_1.forwardRef(function Dropdown(_a, ref) {
    var _b = _a.trigger, trigger = _b === void 0 ? 'hover' : _b, visibleFromProps = _a.visible, onVisibleChange = _a.onVisibleChange, otherProps = tslib_1.__rest(_a, ["trigger", "visible", "onVisibleChange"]);
    var dropdownClassName = ConfigProvider_1.usePrefix('dropdown');
    var getPopupContainer = PopupContainerProvider_1.useGetPopupContainer();
    var _c = hooks_1.useValue({
        valueFromProps: visibleFromProps,
        defaultValue: false,
        onChange: onVisibleChange
    }), visible = _c.value, setVisible = _c.setValue;
    var ctrlCtxValue = react_1.useMemo(function () { return ({ setVisible: setVisible }); }, [setVisible]);
    return (react_1.default.createElement(dropdownCtx.Provider, { value: ctrlCtxValue },
        react_1.default.createElement(rc_dropdown_1.default, tslib_1.__assign({}, otherProps, { visible: visible, onVisibleChange: setVisible, trigger: trigger, getPopupContainer: getPopupContainer, prefixCls: dropdownClassName, placements: placements, ref: ref }))));
});
//# sourceMappingURL=index.js.map